"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PUSHTypes_1 = require("../PUSHTypes");
const PDPSTypes_1 = require("./PDPSTypes");
const PDPSClient_1 = __importDefault(require("./PDPSClient"));
class PDPSOrdersClient extends PDPSClient_1.default {
    constructor(params) {
        super(params);
        this._orders = {};
        this.subscribedToOrders = false;
        this.orderChangedDelegates = {};
        this.private_regexArrayLocal = [
            {
                regex: /^.*\/P\/([0-9]*)\/PM\/([0-9]*)\/O\/([0-9]*)$/,
                method: this._onOrder1,
                converter: {
                    1: 'selectionId',
                    2: 'punterReferenceNumber',
                    3: 'status',
                    4: 'issuedAt',
                    5: 'lastChangedAt',
                    6: 'expiresAt',
                    7: 'requestedForSideStake',
                    8: 'requestedForSidePrice',
                    9: 'orderFillType',
                    10: 'fillOrKillThreshold',
                    11: 'expectedSelectionResetCount',
                    12: 'expectedWithdrawalSequenceNumber',
                    13: 'totalForSideStake',
                    14: 'forSideAmountUnmatched',
                    15: 'totalAgainstSideStake',
                    16: 'totalForSideMakeStake',
                    17: 'totalForSideTakeStake',
                    18: 'polarity',
                    19: 'cancelOnInRunning',
                    20: 'cancelIfSelectionReset',
                    21: 'isFreeBet',
                    22: 'willBeInRunning',
                    23: 'commissionBasis',
                    24: 'makeCommissionRate',
                    25: 'takeCommissionRate',
                    26: 'grossSettlementAmount',
                    27: 'orderCommission',
                    28: 'marketId',
                },
            },
            {
                regex: /(\d{1,4})\/D\S16$/,
                method: this._onSubscribeOrders,
                converter: {
                    0: 'correlationId',
                    1: 'returnCode',
                    2: 'subscriptionId',
                },
            },
        ];
        this.extendRegex(this._regexArrayLocal);
    }
    _onSubscribeOrders({ bodyObject }) {
        const correlationId = bodyObject.correlationId;
        const returnCode = bodyObject.returnCode;
        const subscriptionId = bodyObject.subscriptionId;
        const correlationData = this._correlationData[correlationId];
        const correlationDataParams = this._correlationData[correlationId];
        this.subscribedToOrders = true;
        if (returnCode === 0) {
            this.orderChangedDelegates[correlationData.correlationDataId] =
                correlationDataParams;
            correlationData?.callbackOnSuccess({
                correlationId,
                subscriptionId,
            });
        }
        else {
            correlationData?.callbackOnException.call(this, new PUSHTypes_1.AsyncException({ returnCode }));
        }
    }
    getOrCreateSubscribedOrder(orderId, params) {
        this._orders[orderId] =
            this._orders[orderId] || new PDPSTypes_1.SubscribedOrder({ ...params, orderId });
        this._orders[orderId].updateProperties(params);
        return this._orders[orderId];
    }
    _onOrder1({ headerMatches, bodyObject }) {
        if (headerMatches === null) {
            return;
        }
        const orderId = Number(headerMatches[3]), isNewOrder = this._orders[orderId] === undefined, thisOrder = this.getOrCreateSubscribedOrder(orderId, bodyObject);
        thisOrder.fireOnChangeDelegates(thisOrder, bodyObject);
        for (const subscriptionId in this.orderChangedDelegates) {
            if (isNewOrder) {
                this.orderChangedDelegates[subscriptionId].onNewOrder(thisOrder);
            }
            else {
                this.orderChangedDelegates[subscriptionId].onOrderChange(thisOrder);
            }
        }
    }
    listOrdersByTimeChanged(params) {
        const orders = [];
        if (params?.marketIds) {
            const marketIds = params.marketIds;
            for (const orderId in this._orders) {
                if (this._orders[orderId].marketId > 0) {
                    if (marketIds.includes(this._orders[orderId].marketId)) {
                        orders.push(this._orders[orderId]);
                    }
                }
            }
        }
        else {
            for (const orderId2 in this._orders) {
                if (this._orders[orderId2].marketId > 0) {
                    orders.push(this._orders[orderId2]);
                }
            }
        }
        const SortOnChangedAt = function (a, b) {
            return a.lastChangedAt < b.lastChangedAt ? 1 : -1;
        };
        const sortDescending = true;
        orders.sort(SortOnChangedAt);
        if (sortDescending) {
            orders.reverse();
        }
        return orders;
    }
}
exports.default = PDPSOrdersClient;
